import { getSuggestionAtIndex } from 'owa-mail-search-store';
import { SuggestionKind } from 'owa-search-service';
/**
 * Returns the display text for the suggestion at the given index.
 * @param index The target suggestion's index
 * @returns The display text of the target suggestion
 */
export default function getSuggestionSegments(index) {
    // If no suggestion exists at given index, return null.
    var suggestion = getSuggestionAtIndex(index);
    if (!suggestion) {
        return null;
    }
    switch (suggestion.kind) {
        case SuggestionKind.Keywords:
            return suggestion.Segments;
        default:
            return null;
    }
}
//# sourceMappingURL=getSuggestionSegments.js.map